import React from "react";
import { Icons } from "./icons";
import { Link } from "@/components/link";
import { cn } from "@/lib/utils";
import { DATA } from "@/data/data";

export type ContactInfoProps = {
  className?: string;
  phoneNumber?: string;
};

export default function ContactInfo({ className, phoneNumber }: ContactInfoProps) {
  const phone = phoneNumber
    ? { call: phoneNumber, view: phoneNumber }
    : { call: DATA.phone.call, view: DATA.phone.view };
  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div className="flex flex-row gap-4 items-center justify-start w-full">
        <Icons.location
          height={20}
          width={20}
          className="!h-[20px] !min-w-[20px]"
        />
        <Link
          href="https://maps.app.goo.gl/oGWW7kXDr6FmXN5z9"
          className="max-w-full text-base whitespace-normal h-min py-1"
          title={`${DATA.location.address}, ${DATA.location.addressNumber} - ${DATA.location.city} (${DATA.location.state}) - ${DATA.location.cap}`}
        >
          {DATA.location.address}, {DATA.location.addressNumber} -{" "}
          {DATA.location.city} ({DATA.location.state}) - {DATA.location.cap}
        </Link>
      </div>
      <div className="flex flex-row gap-4 items-center justify-start w-full">
        <Icons.phone height={20} width={20} />
        <Link
          href={`tel:${phone.call}`}
          className="w-min text-base h-min py-1"
          title={phone.view}
        >
          {phone.view}
        </Link>
      </div>
      <div className="flex flex-row gap-4 items-center justify-start w-full">
        <Icons.email height={20} width={20} />
        <Link
          href={`mailto:${DATA.email}`}
          className="w-min text-base h-min py-1"
          title={DATA.email}
        >
          {DATA.email}
        </Link>
      </div>
    </div>
  );
}
